export const columnData = {
  DateCreated: { name: 'Fecha', widthCol: '20%' },
  Message: { name: 'Mensaje', widthCol: '60%' },
  Severity: { name: 'Tipo', widthCol: '20%' }
}
